<template>
  <Body>
    <slot />
  </Body>
</template>

<style scoped>
body {
  background: transparent;
}
</style>
